/**
 * Marca do Orbind — o "orb" com o ponto em orbita, como desenhado no
 * prototipo (regiao do header em `SGW v2`): anel na cor primaria e um ponto
 * orbitando no canto superior direito, recortado do anel por um halo.
 */
export function OrbindLogo({ size = 32, color = 'var(--ob-primary)', halo = 'var(--ob-surface)' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" role="img" aria-label="Orbind" focusable="false">
      <circle cx="14" cy="18" r="10.5" fill="none" stroke={color} strokeWidth="2.6" />
      <circle cx="25" cy="7" r="4.6" fill={halo} />
      <circle cx="25" cy="7" r="3.2" fill={color} />
    </svg>
  )
}
